import React, { useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { Button, Alert, Spinner } from "react-bootstrap"
import PropTypes from "prop-types"
import SwaggerContext from "../SwaggerContext"
import { invitationService } from "../services/invitationService"

const InvitationResponse = ({ token }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")
  const [error, setError] = useState("")
  const swaggerClient = useContext(SwaggerContext)

  const handleAccept = async () => {
    setLoading(true)
    setError("")
    setMessage("")

    try {
      if (!swaggerClient?.invitationApi) {
        throw new Error("API no disponible")
      }

      const result = await invitationService.acceptInvitation(
        swaggerClient.invitationApi,
        token
      )

      if (result.success) {
        setMessage("¡Invitación aceptada! Redirigiendo...")

        setTimeout(() => {
          navigate("/dashboard")
        }, 2000)
      } else {
        const errorMsg = result.error || "Error al aceptar la invitación"
        setError(errorMsg)
      }
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : "Error desconocido"
      setError(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  const handleReject = async () => {
    const confirmed = window.confirm(
      "¿Estás seguro de que deseas rechazar esta invitación?"
    )

    if (!confirmed) return

    setLoading(true)
    setError("")
    setMessage("")

    try {
      if (!swaggerClient?.invitationApi) {
        throw new Error("API no disponible")
      }

      const result = await invitationService.rejectInvitation(
        swaggerClient.invitationApi,
        token
      )

      if (result.success) {
        setMessage("Invitación rechazada. Redirigiendo...")

        setTimeout(() => {
          navigate("/")
        }, 2000)
      } else {
        const errorMsg = result.error || "Error al rechazar la invitación"
        setError(errorMsg)
      }
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : "Error desconocido"
      setError(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="invitation-response">
      <h2 className="mb-4">Responder a Invitación</h2>

      <div className="button-group d-flex gap-2">
        <Button
          variant="success"
          onClick={handleAccept}
          disabled={loading}
          className="d-flex align-items-center gap-2"
        >
          {loading && <Spinner animation="border" size="sm" />}
          {loading ? "Procesando..." : "✓ Aceptar Invitación"}
        </Button>

        <Button
          variant="danger"
          onClick={handleReject}
          disabled={loading}
          className="d-flex align-items-center gap-2"
        >
          {loading && <Spinner animation="border" size="sm" />}
          {loading ? "Procesando..." : "✕ Rechazar Invitación"}
        </Button>
      </div>

      {message && <Alert variant="success" className="mt-3">{message}</Alert>}
      {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
    </div>
  )
}

InvitationResponse.propTypes = {
  token: PropTypes.string.isRequired,
}

export default InvitationResponse
